import type { TaskActivityChipItem } from '@/modules/renter/tasks/services/TasksService';
import type { ListItemModel } from '@/modules/renter/tasksTags/services/TasksTagsService';
import { ANNUAL_STOCKTAKE_ACTIVITY_NAME } from '../constants';
import type { TagId } from '../types';

export function shouldAttachAnnualStocktakeTag(activities: Pick<TaskActivityChipItem, 'name'>[] | null | undefined): boolean
{
    const expected = ANNUAL_STOCKTAKE_ACTIVITY_NAME.toLowerCase();

    return (activities || []).some(a => a.name?.trim().toLowerCase() === expected);
}

export function findTagIdByName(tags: Pick<ListItemModel, 'id' | 'name'>[], name: string): number | null
{
    return tags.find(t => t.name === name)?.id ?? null;
}

export function withTag(tagsIds: TagId[] | null | undefined, tagId: number): TagId[]
{
    const current = tagsIds || [];

    if (tagsIds && current.some(id => Number(id) === tagId))
        return tagsIds;

    return [...current, tagId];
}
